import { render, staticRenderFns } from "./ArRightMenu.vue?vue&type=template&id=0fff4a68"
import script from "./ArRightMenu.vue?vue&type=script&lang=js"
export * from "./ArRightMenu.vue?vue&type=script&lang=js"
import style0 from "./ArRightMenu.vue?vue&type=style&index=0&id=0fff4a68&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fff4a68')) {
      api.createRecord('0fff4a68', component.options)
    } else {
      api.reload('0fff4a68', component.options)
    }
    module.hot.accept("./ArRightMenu.vue?vue&type=template&id=0fff4a68", function () {
      api.rerender('0fff4a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AR/RightMenu/ArRightMenu.vue"
export default component.exports